import { useTranslation } from 'react-i18next'

import { Card, CardTitle, LineItemSelector } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ProductsCard = ({ products }) => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardTitle>{t('Productos')}</CardTitle>
      <Styles.ProductsContainer>
        {products?.map(item => (
          <LineItemSelector key={item.id} lineItem={item} showToggle={false} showStatus={false} finished />
        ))}
      </Styles.ProductsContainer>
    </Card>
  )
}

export default ProductsCard
